import './src/vaadin-confirm-dialog.js';
export * from './src/vaadin-confirm-dialog.js';
